import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4104b5c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gd-user-contact-details mb-gutter type-of-request mt-gutter" }
const _hoisted_2 = { class: "form-field" }
const _hoisted_3 = { class: "grid parentStyle" }
const _hoisted_4 = { class: "grid__item" }
const _hoisted_5 = { class: "sectionHeaderStyle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }, null, -1))
const _hoisted_7 = { style: {"width":"98%"} }
const _hoisted_8 = { class: "shadedArea" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "check" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_13 = { class: "requestHeading" }
const _hoisted_14 = {
  class: "label label--inline typeHeaderStyle",
  "data-auto": "DataAccessRequest-lbl"
}
const _hoisted_15 = { class: "requestInfo" }
const _hoisted_16 = { class: "tooltip-icon iconFix" }
const _hoisted_17 = { "data-auto": "AccessRequestInfo-btn" }
const _hoisted_18 = { class: "label--inline helpfulTextStyle" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"98%"} }, " ")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }, null, -1))
const _hoisted_22 = { style: {"width":"98%"} }
const _hoisted_23 = { class: "shadedArea" }
const _hoisted_24 = { class: "container" }
const _hoisted_25 = { class: "check" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_28 = { class: "requestHeading" }
const _hoisted_29 = {
  class: "label label--inline typeHeaderStyle",
  "data-auto": "DataDeleteRequest-lbl"
}
const _hoisted_30 = { class: "requestInfo" }
const _hoisted_31 = { class: "tooltip-icon" }
const _hoisted_32 = { "data-auto": "DeleteRequestInfo-btn" }
const _hoisted_33 = { class: "label--inline helpfulTextStyle" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"98%"} }, " ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }, null, -1))
const _hoisted_37 = { style: {"width":"98%"} }
const _hoisted_38 = { class: "shadedArea" }
const _hoisted_39 = { class: "container" }
const _hoisted_40 = { class: "check" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_43 = { class: "requestHeading" }
const _hoisted_44 = {
  class: "label label--inline typeHeaderStyle",
  "data-auto": "DataRectificationRequest-lbl"
}
const _hoisted_45 = { class: "requestInfo" }
const _hoisted_46 = { class: "tooltip-icon iconFix" }
const _hoisted_47 = { "data-auto": "RectificationRequestInfo-btn" }
const _hoisted_48 = { class: "label--inline helpfulTextStyle" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"98%"} }, " ")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }, null, -1))
const _hoisted_52 = { style: {"width":"98%"} }
const _hoisted_53 = { class: "shadedArea" }
const _hoisted_54 = { class: "container" }
const _hoisted_55 = { class: "check" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_58 = { class: "requestHeading" }
const _hoisted_59 = {
  class: "label label--inline typeHeaderStyle",
  "data-auto": "DataProcessingRequest-lbl"
}
const _hoisted_60 = { class: "requestInfo" }
const _hoisted_61 = { class: "tooltip-icon iconFix" }
const _hoisted_62 = { "data-auto": "ProcessingRequestInfo-btn" }
const _hoisted_63 = { class: "label--inline helpfulTextStyle" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"2%"} }),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"98%"} }, " ")
], -1))
const _hoisted_66 = { class: "mb-gutter" }
const _hoisted_67 = { class: "form-field form-field--gd--full" }
const _hoisted_68 = { class: "field-row" }
const _hoisted_69 = ["placeholder", "disabled"]
const _hoisted_70 = { class: "mb-gutter" }
const _hoisted_71 = { class: "gd-user-contact-details gd-user-contact-details--alt mb-gutter" }
const _hoisted_72 = { class: "form-field form-field--gd" }
const _hoisted_73 = { class: "field-row" }
const _hoisted_74 = {
  class: "label label--text label--inline",
  "data-auto": "title-lbl"
}
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { value: "" }
const _hoisted_77 = ["value"]
const _hoisted_78 = {
  key: 0,
  class: "form-field form-field--gd",
  id: "otherTitle"
}
const _hoisted_79 = { class: "field-row" }
const _hoisted_80 = {
  class: "label label--text label--inline",
  "data-auto": "othertitle-lbl"
}
const _hoisted_81 = ["disabled", "placeholder"]
const _hoisted_82 = { class: "form-field form-field--gd" }
const _hoisted_83 = { class: "field-row" }
const _hoisted_84 = {
  class: "label label--text label--inline",
  "data-auto": "surname-lbl"
}
const _hoisted_85 = ["disabled", "placeholder"]
const _hoisted_86 = { class: "form-field form-field--gd" }
const _hoisted_87 = { class: "field-row" }
const _hoisted_88 = {
  class: "label label--text label--inline",
  "data-auto": "forename-lbl"
}
const _hoisted_89 = ["disabled", "placeholder"]
const _hoisted_90 = { class: "form-field form-field--gd" }
const _hoisted_91 = { class: "field-row" }
const _hoisted_92 = {
  class: "label label--text label--inline",
  "data-auto": "curraddressline1-lbl"
}
const _hoisted_93 = ["disabled", "placeholder"]
const _hoisted_94 = { class: "form-field form-field--gd" }
const _hoisted_95 = { class: "field-row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_97 = ["disabled", "placeholder"]
const _hoisted_98 = { class: "form-field form-field--gd" }
const _hoisted_99 = { class: "field-row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_101 = ["disabled", "placeholder"]
const _hoisted_102 = { class: "form-field form-field--gd" }
const _hoisted_103 = { class: "field-row" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_105 = ["disabled", "placeholder"]
const _hoisted_106 = { class: "form-field form-field--gd" }
const _hoisted_107 = { class: "field-row" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_109 = ["disabled", "placeholder"]
const _hoisted_110 = { class: "form-field form-field--gd" }
const _hoisted_111 = { class: "field-row" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_113 = ["disabled"]
const _hoisted_114 = { value: "" }
const _hoisted_115 = ["value"]
const _hoisted_116 = { class: "form-field form-field--gd" }
const _hoisted_117 = { class: "field-row" }
const _hoisted_118 = {
  class: "label label--text label--inline",
  "data-auto": "currpostcode-lbl"
}
const _hoisted_119 = ["disabled", "placeholder"]
const _hoisted_120 = { class: "form-field form-field--gd" }
const _hoisted_121 = { class: "field-row" }
const _hoisted_122 = { class: "label label--text label--inline label--multi-line" }
const _hoisted_123 = { class: "gd-field-multi-select form-field--gd__options" }
const _hoisted_124 = ["disabled"]
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-radio" }, null, -1))
const _hoisted_126 = {
  class: "label label--inline label-padding",
  "data-auto": "isPrevAddress-yes-lbl"
}
const _hoisted_127 = ["disabled"]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-radio" }, null, -1))
const _hoisted_129 = {
  class: "label label--inline label-padding",
  "data-auto": "isPrevAddress-no-lbl"
}
const _hoisted_130 = {
  key: 1,
  class: "mb-gutter"
}
const _hoisted_131 = { class: "form-field form-field--gd" }
const _hoisted_132 = { class: "field-row" }
const _hoisted_133 = {
  class: "label label--text label--inline",
  "data-auto": "prevaddressline1-lbl"
}
const _hoisted_134 = ["placeholder", "disabled"]
const _hoisted_135 = { class: "form-field form-field--gd" }
const _hoisted_136 = { class: "field-row" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_138 = ["placeholder", "disabled"]
const _hoisted_139 = { class: "form-field form-field--gd" }
const _hoisted_140 = { class: "field-row" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_142 = ["placeholder", "disabled"]
const _hoisted_143 = { class: "form-field form-field--gd" }
const _hoisted_144 = { class: "field-row" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_146 = ["placeholder", "disabled"]
const _hoisted_147 = { class: "form-field form-field--gd" }
const _hoisted_148 = { class: "field-row" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_150 = ["placeholder", "disabled"]
const _hoisted_151 = { class: "form-field form-field--gd" }
const _hoisted_152 = { class: "field-row" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline" }, null, -1))
const _hoisted_154 = ["disabled"]
const _hoisted_155 = { value: "" }
const _hoisted_156 = ["value"]
const _hoisted_157 = { class: "form-field form-field--gd" }
const _hoisted_158 = { class: "field-row" }
const _hoisted_159 = { class: "label label--text label--inline" }
const _hoisted_160 = ["placeholder", "disabled"]
const _hoisted_161 = { class: "form-field form-field--gd" }
const _hoisted_162 = { class: "field-row" }
const _hoisted_163 = {
  class: "label label--text label--inline",
  "data-auto": "emailaddress-lbl"
}
const _hoisted_164 = ["placeholder", "disabled"]
const _hoisted_165 = { class: "form-field form-field--gd" }
const _hoisted_166 = { class: "field-row" }
const _hoisted_167 = {
  class: "label label--text label--inline",
  "data-auto": "contactnumber-lbl"
}
const _hoisted_168 = ["placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("fieldset", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("legend", _hoisted_5, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.typeOfRequest")), 1)
          ]),
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", null, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "DataAccessRequest",
                          name: "typeofrequest",
                          value: "1",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.RequestType) = $event)),
                          disabled: _ctx.initModel.isDisabled
                        }, null, 8, _hoisted_11), [
                          [_vModelCheckbox, _ctx.newUser.RequestType]
                        ]),
                        _hoisted_12
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.requestDataAccess")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, [
                        _createElementVNode("i", _hoisted_17, [
                          _createTextVNode("i "),
                          _createVNode(_component_v_tooltip, {
                            activator: "parent",
                            location: "bottom",
                            width: "320px",
                            contained: true,
                            "open-on-click": true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getBrandTranslation(
                                "labeltext.tooltipAccessRequest"
                              )), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_18, [
                    _createElementVNode("div", {
                      innerHTML: 
                        _ctx.getTranslatedValueEx(
                          'labeltext.dataAccessRequestHelpfulInfo'
                        )
                      
                    }, null, 8, _hoisted_19)
                  ])
                ])
              ])
            ]),
            _hoisted_20,
            _createElementVNode("tr", null, [
              _hoisted_21,
              _createElementVNode("td", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", null, [
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "DataDeleteRequest",
                          name: "typeofrequest",
                          value: "2",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUser.RequestType) = $event)),
                          disabled: _ctx.initModel.isDisabled
                        }, null, 8, _hoisted_26), [
                          [_vModelCheckbox, _ctx.newUser.RequestType]
                        ]),
                        _hoisted_27
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.requestDataDelete")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, [
                        _createElementVNode("i", _hoisted_32, [
                          _createTextVNode("i "),
                          _createVNode(_component_v_tooltip, {
                            activator: "parent",
                            location: "bottom",
                            width: "320px",
                            contained: true,
                            "open-on-click": true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getBrandTranslation(
                                "labeltext.tooltipDataDeletion"
                              )), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_33, [
                    _createElementVNode("div", {
                      innerHTML: 
                        _ctx.getTranslatedValueEx(
                          'labeltext.dataDeleteRequestHelpfulInfo'
                        )
                      
                    }, null, 8, _hoisted_34)
                  ])
                ])
              ])
            ]),
            _hoisted_35,
            _createElementVNode("tr", null, [
              _hoisted_36,
              _createElementVNode("td", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", null, [
                      _createElementVNode("div", _hoisted_40, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "DataRectificationRequest",
                          name: "typeofrequest",
                          value: "3",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.RequestType) = $event)),
                          disabled: _ctx.initModel.isDisabled
                        }, null, 8, _hoisted_41), [
                          [_vModelCheckbox, _ctx.newUser.RequestType]
                        ]),
                        _hoisted_42
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.requestDataRect")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("span", _hoisted_46, [
                        _createElementVNode("i", _hoisted_47, [
                          _createTextVNode("i "),
                          _createVNode(_component_v_tooltip, {
                            activator: "parent",
                            location: "bottom",
                            width: "320px",
                            contained: true,
                            "open-on-click": true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getBrandTranslation(
                                "labeltext.tooltipDataRectification"
                              )), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_48, [
                    _createElementVNode("div", {
                      innerHTML: 
                        _ctx.getTranslatedValueEx(
                          'labeltext.dataRectifyRequestHelpfulInfo'
                        )
                      
                    }, null, 8, _hoisted_49)
                  ])
                ])
              ])
            ]),
            _hoisted_50,
            _createElementVNode("tr", null, [
              _hoisted_51,
              _createElementVNode("td", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", null, [
                      _createElementVNode("div", _hoisted_55, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "DataProcessingRequest",
                          name: "typeofrequest",
                          value: "4",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUser.RequestType) = $event)),
                          disabled: _ctx.initModel.isDisabled
                        }, null, 8, _hoisted_56), [
                          [_vModelCheckbox, _ctx.newUser.RequestType]
                        ]),
                        _hoisted_57
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.requestDataObject")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("span", _hoisted_61, [
                        _createElementVNode("i", _hoisted_62, [
                          _createTextVNode("i "),
                          _createVNode(_component_v_tooltip, {
                            activator: "parent",
                            location: "bottom",
                            width: "320px",
                            contained: true,
                            "open-on-click": true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getBrandTranslation("labeltext.tooltipDataObject")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_63, [
                    _createElementVNode("div", {
                      innerHTML: 
                        _ctx.getTranslatedValueEx(
                          'labeltext.dataProcessRequestHelpfulInfo'
                        )
                      
                    }, null, 8, _hoisted_64)
                  ])
                ])
              ])
            ]),
            _hoisted_65
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.reqDetailsText")), 1)
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("label", _hoisted_68, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.DetailsOfRequest) = $event)),
          placeholder: 
            _ctx.initModel.isDisabled == true
              ? ''
              : _ctx.translate('labeltext.reqDetailsPlc')
          ,
          disabled: _ctx.initModel.isDisabled,
          rows: "2"
        }, null, 8, _hoisted_69), [
          [_vModelText, _ctx.newUser.DetailsOfRequest]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_70, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.partAHeadingText")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.getBrandTranslation("labeltext.partABodyText")), 1)
    ]),
    _createElementVNode("div", _hoisted_71, [
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("label", _hoisted_73, [
          _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.title")), 1),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.initModel.selectedTitleValue) = $event)),
            name: "title",
            disabled: _ctx.initModel.isDisabled
          }, [
            _createElementVNode("option", _hoisted_76, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.titleDefaultValue")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDropdownValues, (titleDDL, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: titleDDL.value,
                key: index
              }, _toDisplayString(_ctx.getDDLTranslatedValue(`labeltext.${titleDDL.resourceKeyVal}`)), 9, _hoisted_77))
            }), 128))
          ], 8, _hoisted_75), [
            [_vModelSelect, _ctx.initModel.selectedTitleValue]
          ])
        ])
      ]),
      (_ctx.initModel.selectedTitleValue == '5')
        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
            _createElementVNode("label", _hoisted_79, [
              _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.otherTitleLabel")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.initModel.selectedOtherTitle) = $event)),
                name: "othertitle",
                maxlength: "15",
                disabled: _ctx.initModel.isDisabled,
                placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.otherTitlePlc')
            
              }, null, 8, _hoisted_81), [
                [_vModelText, _ctx.initModel.selectedOtherTitle]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("label", _hoisted_83, [
          _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.surname")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newUser.LastName) = $event)),
            name: "surname",
            maxlength: "30",
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.surname')
            
          }, null, 8, _hoisted_85), [
            [_vModelText, _ctx.newUser.LastName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("label", _hoisted_87, [
          _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.forename")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.FirstName) = $event)),
            name: "forename",
            maxlength: "50",
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.forename')
            
          }, null, 8, _hoisted_89), [
            [_vModelText, _ctx.newUser.FirstName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("label", _hoisted_91, [
          _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.currentAddress")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newUser.CurrentAddress.AddressLine1) = $event)),
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.addline1Plc')
            ,
            name: "curraddressline1",
            maxlength: "100"
          }, null, 8, _hoisted_93), [
            [_vModelText, _ctx.newUser.CurrentAddress.AddressLine1]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("label", _hoisted_95, [
          _hoisted_96,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newUser.CurrentAddress.AddressLine2) = $event)),
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.addLine2Plc')
            ,
            name: "curraddressline2",
            maxlength: "100"
          }, null, 8, _hoisted_97), [
            [_vModelText, _ctx.newUser.CurrentAddress.AddressLine2]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("label", _hoisted_99, [
          _hoisted_100,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newUser.CurrentAddress.AddressLine3) = $event)),
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.addLine3Plc')
            ,
            name: "curraddressline3",
            maxlength: "100"
          }, null, 8, _hoisted_101), [
            [_vModelText, _ctx.newUser.CurrentAddress.AddressLine3]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_102, [
        _createElementVNode("label", _hoisted_103, [
          _hoisted_104,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newUser.CurrentAddress.Town) = $event)),
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.townPlc')
            ,
            name: "currtown",
            maxlength: "50"
          }, null, 8, _hoisted_105), [
            [_vModelText, _ctx.newUser.CurrentAddress.Town]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("label", _hoisted_107, [
          _hoisted_108,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newUser.CurrentAddress.County) = $event)),
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.countyPlc')
            ,
            name: "currcounty",
            maxlength: "50"
          }, null, 8, _hoisted_109), [
            [_vModelText, _ctx.newUser.CurrentAddress.County]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_110, [
        _createElementVNode("label", _hoisted_111, [
          _hoisted_112,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newUser.CurrentAddress.Country) = $event)),
            disabled: _ctx.initModel.isDisabled,
            name: "currcountry"
          }, [
            _createElementVNode("option", _hoisted_114, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.countryDefaultValue")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.CountriesList, (countryVal, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: countryVal.CountryCode,
                key: index
              }, _toDisplayString(countryVal.CountryName), 9, _hoisted_115))
            }), 128))
          ], 8, _hoisted_113), [
            [_vModelSelect, _ctx.newUser.CurrentAddress.Country]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_116, [
        _createElementVNode("label", _hoisted_117, [
          _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.postCode")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newUser.CurrentAddress.PostCode) = $event)),
            disabled: _ctx.initModel.isDisabled,
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.postCode')
            ,
            name: "currpostcode",
            maxlength: "25"
          }, null, 8, _hoisted_119), [
            [_vModelText, _ctx.newUser.CurrentAddress.PostCode]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_120, [
        _createElementVNode("div", _hoisted_121, [
          _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.prevAddressWarning")), 1),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "PrevAddressYes",
                value: "true",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newUser.PrevAddress) = $event)),
                disabled: _ctx.initModel.isDisabled,
                onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsPrevAddress && _ctx.clearInputFieldsPrevAddress(...args)))
              }, null, 40, _hoisted_124), [
                [_vModelRadio, _ctx.newUser.PrevAddress]
              ]),
              _hoisted_125,
              _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.$t("labeltext.yesText")), 1)
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "PrevAddressNo",
                value: "false",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newUser.PrevAddress) = $event)),
                disabled: _ctx.initModel.isDisabled,
                onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsPrevAddress && _ctx.clearInputFieldsPrevAddress(...args)))
              }, null, 40, _hoisted_127), [
                [_vModelRadio, _ctx.newUser.PrevAddress]
              ]),
              _hoisted_128,
              _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.$t("labeltext.noText")), 1)
            ])
          ])
        ])
      ]),
      (_ctx.newUser.PrevAddress.toString() === 'true')
        ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("label", _hoisted_132, [
                _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.prevAddress")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newUser.PreviousAddress.AddressLine1) = $event)),
                  placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.addline1Plc')
              ,
                  disabled: _ctx.initModel.isDisabled,
                  name: "prevaddressline1",
                  maxlength: "100"
                }, null, 8, _hoisted_134), [
                  [_vModelText, _ctx.newUser.PreviousAddress.AddressLine1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_135, [
              _createElementVNode("label", _hoisted_136, [
                _hoisted_137,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newUser.PreviousAddress.AddressLine2) = $event)),
                  placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.addLine2Plc')
              ,
                  disabled: _ctx.initModel.isDisabled,
                  name: "prevaddressline2",
                  maxlength: "100"
                }, null, 8, _hoisted_138), [
                  [_vModelText, _ctx.newUser.PreviousAddress.AddressLine2]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_139, [
              _createElementVNode("label", _hoisted_140, [
                _hoisted_141,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newUser.PreviousAddress.AddressLine3) = $event)),
                  placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.addLine3Plc')
              ,
                  disabled: _ctx.initModel.isDisabled,
                  name: "prevaddressline3",
                  maxlength: "100"
                }, null, 8, _hoisted_142), [
                  [_vModelText, _ctx.newUser.PreviousAddress.AddressLine3]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("label", _hoisted_144, [
                _hoisted_145,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newUser.PreviousAddress.Town) = $event)),
                  placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.getTranslatedValueEx('labeltext.townPlc')
              ,
                  disabled: _ctx.initModel.isDisabled,
                  name: "prevtown",
                  maxlength: "50"
                }, null, 8, _hoisted_146), [
                  [_vModelText, _ctx.newUser.PreviousAddress.Town]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("label", _hoisted_148, [
                _hoisted_149,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newUser.PreviousAddress.County) = $event)),
                  placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.getTranslatedValueEx('labeltext.countyPlc')
              ,
                  disabled: _ctx.initModel.isDisabled,
                  name: "prevcounty",
                  maxlength: "50"
                }, null, 8, _hoisted_150), [
                  [_vModelText, _ctx.newUser.PreviousAddress.County]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_151, [
              _createElementVNode("label", _hoisted_152, [
                _hoisted_153,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newUser.PreviousAddress.Country) = $event)),
                  disabled: _ctx.initModel.isDisabled,
                  class: "fixedWidth",
                  name: "prevcountry"
                }, [
                  _createElementVNode("option", _hoisted_155, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.countryDefaultValue")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.CountriesList, (countryVal, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: countryVal.CountryCode,
                      key: index
                    }, _toDisplayString(countryVal.CountryName), 9, _hoisted_156))
                  }), 128))
                ], 8, _hoisted_154), [
                  [_vModelSelect, _ctx.newUser.PreviousAddress.Country]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_157, [
              _createElementVNode("label", _hoisted_158, [
                _createElementVNode("span", _hoisted_159, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.postCode")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.newUser.PreviousAddress.PostCode) = $event)),
                  placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.getTranslatedValueEx('labeltext.postCode')
              ,
                  disabled: _ctx.initModel.isDisabled,
                  name: "prevpostcode",
                  maxlength: "25"
                }, null, 8, _hoisted_160), [
                  [_vModelText, _ctx.newUser.PreviousAddress.PostCode]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_161, [
        _createElementVNode("label", _hoisted_162, [
          _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.emailAddress")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newUser.EmailAddress) = $event)),
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.getTranslatedValueEx('labeltext.emailAddress')
            ,
            disabled: _ctx.initModel.isDisabled,
            name: "emailaddress",
            maxlength: "50"
          }, null, 8, _hoisted_164), [
            [_vModelText, _ctx.newUser.EmailAddress]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_165, [
        _createElementVNode("label", _hoisted_166, [
          _createElementVNode("span", _hoisted_167, _toDisplayString(_ctx.getTranslatedValueEx("labeltext.contactNumber")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.newUser.ContactNumber) = $event)),
            placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.getTranslatedValueEx('labeltext.contactNumber')
            ,
            disabled: _ctx.initModel.isDisabled,
            name: "contactnumber",
            maxlength: "15"
          }, null, 8, _hoisted_168), [
            [_vModelText, _ctx.newUser.ContactNumber]
          ])
        ])
      ])
    ])
  ]))
}